import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import DeleteButton from '../fw/DeleteButton.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {injectIntl, defineMessages, FormattedMessage, IntlShape} from 'react-intl';
import AppPanel from '../fw/AppPanel.react';
import {Link} from 'react-router';
import handlers from '../view/box/apps/edit/handlers';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddonView.title', 'defaultMessage': 'Application Addon'}
});

interface ChannelAddonViewProps {
    intl: IntlShape;
    user: User;
}

class ChannelAddonView extends React.Component<ChannelAddonViewProps> {

    typeName = 'channelAddons';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const data = this.props.user.organisation.channel.channelAddon;
        let channel = this.props.user.organisation.channel;
        let type = types[this.typeName];

        let handlerName = null;

        if (this.props.user.organisation.channel.channelAddon.addonDef) {
            handlerName = this.props.user.organisation.channel.channelAddon.addonDef.handler;
        }

        let handler = handlers[handlerName];

        return (
            <AppPanel breadcrumbParams={[
                {type: type, data: data},
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['channels'], data: channel},
            ]}  title={this.props.intl.formatMessage(messages.title)}>
                <DetailBox data={data} metadata={type} urlMapping={urlMapping}>
                    <DetailToolBar data={data} metadata={type} organisationId={this.props.user.organisation.realId} urlMapping={urlMapping}>
                        <DeleteButton
                            data={data}
                            deleteFatQuery={Relay.QL `fragment on DeleteChannelAddonPayload {
                                                            updatedNode {
                                                                id
                                                            },
                                                            channel {
                                                                channelAddons(first: 100) {
                                                                    edges {
                                                                        node {
                                                                            id
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                        }`}
                            deleteMutation={Relay.QL `mutation { deleteChannelAddon }`}
                            metadata={type}
                            organisationId={this.props.user.organisation.realId}
                            parent={channel}
                            redirectToList
                            types={types}
                            urlMapping={urlMapping}
                        />
                        {handler ? <Link className="btn btn-default" to={urlMapping.getUrl(types['channelAddons'], "config", data)} type="button"><span className="fa fa-cog fa-fw"/> <FormattedMessage defaultMessage="Configure" id="channelAddon.config" /></Link> : null}
                    </DetailToolBar>

                    <h2>{data.name ? data.name : (data.addonDef ? data.addonDef.name : '?')}</h2>

                    <TableDetail columns={{
                        'addonDef.name': {},
                        'sourceDef.name': {},
                        'connectedChannel': {
                            render: (column, item) => {
                                if (!item) {
                                    return null;
                                }

                                let channelDefName = '';
                                if (item['channelDef']) {
                                    channelDefName =  item['channelDef']['name'];
                                }

                                if (item['name']) {
                                    return item['name'] + " / " + channelDefName;
                                } else {
                                    return channelDefName;
                                }
                            },
                        }
                    }} data={data} metadata={type} />
                </DetailBox>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddonView), (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.channelAddon;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        channelAddonId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        organisation_id,
                        channelDef {
                            id,
                            name
                        },
                        channelAddon(id: $channelAddonId) {
                            id,
                            channel_id,
                            organisation_id,
                            connectedChannel_id,
                            connectedChannel {
                                id,
                                realId,
                                name,
                                channelDef {
                                    id,
                                    name,
                                    type
                                }
                            },
                            name,
                            sourceDef {
                                id,
                                name,
                            },
                            addonDef {
                                id,
                                name,
                                handler,
                                channelDef {
                                    id,
                                    name,
                                    icon,
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
});
